import { createContext, MutableRefObject } from 'react'

export type MetroSyncContextType = {
  broadcastChannelRef: MutableRefObject<BroadcastChannel | null> | null
}

export const MetroSyncContext = createContext<MetroSyncContextType>({
  broadcastChannelRef: null,
})
